import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.CONTROL_GROUP,
  api: printControlGroup,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintControlGroupAction.js